namespace Portico.Directives {

	import models = Portico.Models;
	import services = Portico.Services;

    export interface ITcButtonController {
		clazz: string;
		disable: string;
		isAllowed: () => boolean;
		onDenied: () => void;
		onInvalid: () => void;
		onSuccess: () => void;
		type: string;
		validate: boolean;

        tcForm: ITcFormController;

		isDisabled: () => boolean;
		onClick: () => void;
    }

    export class TcButtonController implements ITcButtonController {
        clazz: string;
		disable: string;
		isAllowed: () => boolean;
		onDenied: () => void;
		onInvalid: () => void;
		onSuccess: () => void;
		type: string;
		validate: boolean;

        tcForm: ITcFormController;

		constructor(
			private $q: angular.IQService
		) {
		}

		isDisabled(): boolean {
			if (this.tcForm && this.tcForm.isDisabled()) {
				return true;
			}

			if (this.disable === 'all' || this.disable === 'invalid') {
				if (!this.tcForm || !this.tcForm.ngForm || !this.tcForm.ngForm.$valid) {
					return true;
				}
			}

			if (this.disable === 'all' || this.disable === 'denied') {
				if (this.isAllowed && !this.isAllowed()) {
					return true;
				}
			}

			return false;
		}

		onClick(): void {
			if (this.tcForm) {
				this.tcForm.ngForm.$setSubmitted();

				// need to do a better job with promises so the form can be enabled after onClick resolves
				if (this.type === 'submit') {
					this.tcForm.disabled = true;
				}
			}

			if (!this.validate || !this.tcForm || this.tcForm.ngForm.$valid) {
				if (this.isAllowed) {
					this.$q.when(this.isAllowed()).then((result: boolean) => {
						if (!result) {
							if (this.onDenied) {
								this.$q.when(this.onDenied()).finally(() => {
									if (this.tcForm) {
										this.tcForm.disabled = false;
									}
								});
							}
						} else if (this.onSuccess) {
							this.$q.when(this.onSuccess()).finally(() => {
								if (this.tcForm) {
									this.tcForm.disabled = false;
								}
							});
						}
					});
				} else if (this.onSuccess) {
					this.$q.when(this.onSuccess()).finally(() => {
						if (this.tcForm) {
							this.tcForm.disabled = false;
						}
					});
				}
            } else if (this.onInvalid) {
                this.$q.when(this.onInvalid()).finally(() => {
                    if (this.tcForm) {
                        this.tcForm.disabled = false;
                    }
                });
            } else if (this.tcForm) {
                this.tcForm.disabled = false;
            }
		}
    }

    angular.module('app').directive('tcButton', [
        '$compile', (
            $compile: angular.ICompileService) => {
			return {
				bindToController: {
					clazz: '@',
					disable: '@',
					isAllowed: '&?',
					onDenied: '&?',
					onInvalid: '&?',
					onSuccess: '&?',
					type: '@',
					validate: '@'
				},
				controller: ['$q', <any>TcButtonController],
				controllerAs: '$button',
				link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
					const tcButton: ITcButtonController = $ctrl[0];
					const tcForm: ITcFormController = $ctrl[1];

					tcButton.tcForm = tcForm;
					tcButton.type = tcButton.type ? tcButton.type : 'button';
				},
				restrict: 'E',
				require: ['tcButton', '?^tcForm'],
				scope: true,
				template:
					`<button type="{{$button.type}}" class="{{$button.clazz}}" ng-click="$button.onClick()" ng-disabled="$button.isDisabled()">
						<div ng-transclude>
						</div>
					</button>`,
				transclude: true
			};
		}
	]);
}